export { extractUniqueCitiesFromArray } from './locations';
export { setImageSrc } from './locations';

export const noop = () => {};
